import { render, staticRenderFns } from "./RtbData.vue?vue&type=template&id=0bd5c6a0"
import script from "./RtbData.vue?vue&type=script&lang=js"
export * from "./RtbData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports